import { CAMPAIGN_BUILDER_STEP_NAMES } from '../constants';

type CampaignBuilderStepName = (typeof CAMPAIGN_BUILDER_STEP_NAMES)[keyof typeof CAMPAIGN_BUILDER_STEP_NAMES];

const FIELD_STEP_MAP: Record<string, CampaignBuilderStepName> = {
  name: CAMPAIGN_BUILDER_STEP_NAMES.SETUP,
  budget: CAMPAIGN_BUILDER_STEP_NAMES.SETUP,
  startTime: CAMPAIGN_BUILDER_STEP_NAMES.SETUP,
  endTime: CAMPAIGN_BUILDER_STEP_NAMES.SETUP,
  dateRange: CAMPAIGN_BUILDER_STEP_NAMES.SETUP,
  isPreemptible: CAMPAIGN_BUILDER_STEP_NAMES.SETUP,
  publishers: CAMPAIGN_BUILDER_STEP_NAMES.CONTENT,
  packageId: CAMPAIGN_BUILDER_STEP_NAMES.CONTENT,
  selectedPackage: CAMPAIGN_BUILDER_STEP_NAMES.CONTENT,
  locationTargetings: CAMPAIGN_BUILDER_STEP_NAMES.TARGETING,
  zipCodes: CAMPAIGN_BUILDER_STEP_NAMES.TARGETING,
  ages: CAMPAIGN_BUILDER_STEP_NAMES.TARGETING,
  audiences: CAMPAIGN_BUILDER_STEP_NAMES.TARGETING,
  retargetings: CAMPAIGN_BUILDER_STEP_NAMES.TARGETING,
  platform: CAMPAIGN_BUILDER_STEP_NAMES.TARGETING,
  contentTargetings: CAMPAIGN_BUILDER_STEP_NAMES.TARGETING,
  allowMatureContent: CAMPAIGN_BUILDER_STEP_NAMES.TARGETING,
  dayParting: CAMPAIGN_BUILDER_STEP_NAMES.DELIVERY,
  pacingSchedules: CAMPAIGN_BUILDER_STEP_NAMES.DELIVERY,
  pacingType: CAMPAIGN_BUILDER_STEP_NAMES.DELIVERY,
  pacingWeight: CAMPAIGN_BUILDER_STEP_NAMES.DELIVERY,
  frequency: CAMPAIGN_BUILDER_STEP_NAMES.DELIVERY,
  frequencyCapUnit: CAMPAIGN_BUILDER_STEP_NAMES.DELIVERY,
  adFormat: CAMPAIGN_BUILDER_STEP_NAMES.ADS,
  adDuration: CAMPAIGN_BUILDER_STEP_NAMES.ADS,
  ads: CAMPAIGN_BUILDER_STEP_NAMES.ADS,
  weight: CAMPAIGN_BUILDER_STEP_NAMES.ADS,
};

export const resolveStepNameFromField = (fieldName: string): CampaignBuilderStepName => {
  const normalizedFieldName = fieldName.replace(/^lineItemField_/, '');
  const rootFieldName = normalizedFieldName.split(/[.[]/)[0];

  return FIELD_STEP_MAP[rootFieldName] ?? CAMPAIGN_BUILDER_STEP_NAMES.SETUP;
};
